<template>
  <div class="carPark-result" :style="{height: height+'px'}">
    <loading v-if="loadingImg"></loading>
    <div v-if="!loadingImg">

      <div class="box">
        <div class="image_box">
          <img v-if="isSucess" src="../../assets/iconImage/pay_success.png" alt="">
          <img v-else src="../../assets/iconImage/pay_error.png" alt="">
        </div>
        <div class="payResult_text">{{isSucess?'支付成功':'支付失败'}}</div>
      </div>

      <div class="detail_content">
        <div class="item">订单号：{{detailData.orderSn}}</div>
        <div class="item">收款方：{{detailData.payerSide}}</div>
        <div class="item">总费用：{{detailData.orderMoney / 100}}元</div>
        <div class="item">支付状态：{{detailData.payStatus?'完成':'待支付'}}</div>
        <div class="item">支付详情：{{detailData.payId == 1?'微信支付':detailData.payId == 2?'支付宝支付':'现金支付'}}</div>
        <div class="item">实际支付：{{detailData.payMoney / 100}}元</div>
        <div class="item">付款时间：{{dCreateTime(detailData.endTime)}}</div>
      </div>

      <div class="detail_bottom">
        <div class="bottom_text">
          <span class="text_bold">温馨提示：</span>
          付款成功后，请您在<span style="color:#FF6600">15分钟</span>内驶离车场，否则您可能需要支付额外的超时费用。
        </div>

        <div class="bottom_btn">
          <van-button class="returnDetail" color="#188357" @click="returnDetail">查看缴费详情</van-button>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Loading from '@/components/loading';
import Vue from 'vue';
export default {
  data() {
    return {
      // 页面整体高度
      height: 0,
      loadingImg: true,
      isSucess: true,
      detailData: {},
    };
  },
  components: {
    Loading,
  },
  mounted() {
    document.title = '支付结果';
    this.height = document.documentElement.clientHeight;
    this.getResult();
  },
  methods: {
    // 获取详情页数据
    getResult() {
      let formData = new FormData();
      formData.append('orderNo', this.$route.query.orderNo);
      formData.append('carPlate', this.$route.query.carPlate);
      this.$request.post(`/appserver/v1/carPark/getPayDetail`, formData).then(res => {
        console.log(res.data.data, '支付结果');
        if (res.data.data) {
          console.log(res.data.data);
          this.detailData = res.data.data;
        } else {
          this.$toast('查询结果失败');
        }
        this.loadingImg = false;
      }).catch(e => {
        this.$toast(e);
      })
    },

    //  跳转回详情页
    returnDetail() {
      this.$router.replace({
          path: '/carParkDetail',
          query: {
            isConfim: true,
            address: this.detailData.address,
            carPlate: this.detailData.carPlate,
            orderSn: this.detailData.orderSn,
            inTime: this.detailData.inTime,
            endTime: this.detailData.endTime,
            feeRule: this.detailData.feeRule,
            orderMoney: this.detailData.orderMoney,
            payMoney: this.detailData.payMoney,
            payId: this.detailData.payId,
          }
        })
    },




    dCreateTime(value) {
      var date = new Date(parseInt(value));
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() + ' ';
      var h = date.getHours() + ':';
      var m = date.getMinutes() + ':';
      var s = date.getSeconds();
      var df = Y + M + D + h + m + s;
      return df;
    },
  },
};
</script>
<style lang="scss" scoped>
.carPark-result {
  position: relative;
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-size: 17px;
    font-weight: bold;
    margin: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #dedede;
    .image_box {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        margin-right: 15px;
      }
    }
  }

  .detail_content {
    padding: 0 15px;
    padding-bottom: 20px;
    border-bottom: 10px solid #f5f5f5;
    .item {
      margin-top: 15px;
      color: #333;
      font-size: 13px;
    }
  }

  .detail_bottom {
    padding: 0 15px;
    margin-top: 25px;
    color: #333;
    // position: relative;
    .bottom_text {
      font-size: 12px;
      letter-spacing: 0.5px;
      line-height: 25px;
      .text_bold {
        font-weight: bold;
        font-size: 13px;
      }
    }

    .bottom_btn {
      position: absolute;
      left: 0;
      bottom: 20px;
      width: 100%;
      text-align: center;
      .returnDetail {
        width: 90%;
        letter-spacing: 0.5px;
        font-size: 13px;
      }
    }
  }
}
</style>
